export default __webpack_public_path__ + "static/media/deposit.8cfa9435.svg";